import React from 'react';
import { Route } from 'react-router-dom';

import IndexPage from 'pages/subcontractor/index';
import ProfilePage from 'pages/subcontractor/profile';
import UploadPage from 'pages/subcontractor/upload';

const collection = 'subcontractor';
const menuItem = ['DATABASE', 'SUBCONTRACTOR'];

const routes = [
  <Route
    path={`/${collection}`}
    element={<IndexPage menuItem={menuItem} title="判頭列表" collection={collection} />}
  />,
  <Route
    path={`/${collection}/profile/:_id`}
    element={<ProfilePage menuItem={menuItem} title="判頭" collection={collection} editMode="edit" />}
  />,
  <Route
    path={`/${collection}/copy/:_id`}
    element={<ProfilePage menuItem={menuItem} title="新增判頭" collection={collection} editMode="copy" />}
  />,
  <Route
    path={`/${collection}/new`}
    element={<ProfilePage menuItem={menuItem} title="新增判頭" collection={collection} editMode="new" />}
  />,
  <Route
    path={`/${collection}/import`}
    element={<UploadPage menuItem={menuItem} title="批量新增判頭" collection={collection} />}
  />
];

export default routes;
